var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhanHeQuanLyBn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#00BAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9118 15.3333C27.9118 18.2789 25.4888 20.6667 22.5 20.6667C19.5111 20.6667 17.0882 18.2789 17.0882 15.3333C17.0882 12.3878 19.5111 10 22.5 10C25.4888 10 27.9118 12.3878 27.9118 15.3333ZM17.2319 26.6741C17.1847 26.6692 17.1368 26.6667 17.0882 26.6667C16.341 26.6667 15.7353 27.2636 15.7353 28C15.7353 28.1424 15.758 28.2795 15.7999 28.4082L17.2319 26.6741ZM23.0377 29.4983C23.9117 29.8415 24.5294 30.6829 24.5294 31.6667C24.5294 32.8421 23.6474 33.8146 22.5 33.9764V34H22.1618H22.008H19.2916H18.4412H17.0882C13.7258 34 11 31.3137 11 28C11 24.6863 13.7258 22 17.0882 22H21.0919H21.4135H22.1618H25.2059H26.2223H27.9118C31.2742 22 34 24.6863 34 28C34 31.3137 31.2742 34 27.9118 34H25.0319C25.5632 33.3661 25.8824 32.5531 25.8824 31.6667C25.8824 30.1291 24.922 28.8126 23.5603 28.2679L23.0377 29.4983ZM21.8477 23.3333H22.1618H24.1894L20.2254 32.6667H17.0882C16.176 32.6667 15.324 32.4125 14.6012 31.972L21.1266 24.0703L21.8477 23.3333ZM29.2647 28C29.2647 28.7364 28.659 29.3333 27.9118 29.3333V26.6667C28.659 26.6667 29.2647 27.2636 29.2647 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhanHeQuanLyBn);
export default __webpack_public_path__ + "static/media/PhanHeQuanLyBN.9d05f124.svg";
export { ForwardRef as ReactComponent };